// Vistas top-level del módulo pipeline-constructor.

import { InventoryView } from './components/InventoryView';
import { LeadsTable } from './components/LeadsTable';
import { RunsView } from './components/RunsView';

export function LeadsView() {
  return (
    <div className="o-page space-y-4">
      <header>
        <h1 className="text-xl font-semibold text-white">Leads de obra pública</h1>
        <p className="text-xs text-white/50">
          Procedimientos federales (LOPSRM) matched contra tu inventario. Score ≥80 = vale reaccionar.
        </p>
      </header>
      <LeadsTable />
    </div>
  );
}

export function PipelineInventoryView() {
  return (
    <div className="o-page space-y-4">
      <InventoryView />
    </div>
  );
}

export function PipelineRunsView() {
  return (
    <div className="o-page space-y-4">
      <RunsView />
    </div>
  );
}
